import { call, put } from "redux-saga/effects";
import { notification } from "antd";
import { Creators as MeasurementActions } from "../ducks/measurement";
import {
  indexAll,
  inactivate,
  activate,
} from "../../services/measurementService";

export function* indexMeasurements(action) {
  try {
    const {
      data: { results },
    } = yield call(indexAll, action.payload);
    yield put(MeasurementActions.indexSuccess(results));
  } catch (error) {
    yield put(MeasurementActions.indexError(error));
  }
}

export function* inactivateMeasurement(action) {
  try {
    yield call(inactivate, action.payload);
  } catch (error) {
    notification.error({
      message: "Medição não foi inativada. Contate o suporte",
    });
  }
  yield put(
    MeasurementActions.index(action.payload.groupId, action.payload.farmId)
  );
}

export function* activateMeasurement(action) {
  try {
    yield call(activate, action.payload);
  } catch (error) {
    notification.error({
      message: "Medição não foi ativada. Contate o suporte",
    });
  }
  yield put(
    MeasurementActions.index(action.payload.groupId, action.payload.farmId)
  );
}
